<script>
import SkeletonLoader from '@components/skeleton-loader.vue'

export default {
  components: { SkeletonLoader },
  inheritAttrs: false,
  props: {
    active: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
  },
}
</script>

<template>
  <div class="d-inline-block">
    <div v-if="loading">
      <SkeletonLoader style="width: 80px; height: 40px" />
    </div>
    <div
      v-else
      :class="{ [$style.selector]: true, [$style.active]: active }"
      v-bind="$attrs"
      class="d-inline-block"
      data-base-selector
      v-on="$listeners">
      <p class="button-text">
        <slot />
      </p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.selector {
  padding: 8px 16px;
  cursor: pointer;
  user-select: none;
  border: 1px solid $primary-blue;
  border-radius: 8px;

  p {
    color: $primary-blue;
    white-space: nowrap;
    @media (max-width: $lg-breakpoint) {
      line-height: 16px;
    }
  }

  &.active {
    color: $white;
    background-color: $primary-blue;

    p {
      color: $white;
      white-space: nowrap;
    }
  }
}
</style>
